export default String.raw`
.newsSection {
    padding: 0 5%;

    &__container {
        &::before {
            visibility: hidden;
        }
    
        &::after {
            visibility: hidden;
        }
    }

    &__arrows {
        visibility: hidden;
    }

    &__header {
        h2 {
            @include h3-headline;
        }
    }

    &__slide {
        width: calc(100% / 1.4);
    }
}
`